import { lazy, Suspense } from 'react'

import { LoadingTurbo } from 'atoms'

import { OpportunitiesListScreenComponent } from './OpportunitiesListScreen.types'
import { useOpportunitiesListScreen } from './useOpportunitiesListScreen'

const OpportunitiesListScreenDesktop = lazy(() => import('./OpportunitiesListScreen.desktop'))

export const OpportunitiesListScreen: OpportunitiesListScreenComponent = ({
  navigation,
  route
}) => {
  const props = useOpportunitiesListScreen({ navigation, route })

  const Screen = OpportunitiesListScreenDesktop

  return (
    <Suspense fallback={<LoadingTurbo />}>
      <Screen {...props} />
    </Suspense>
  )
}
